export const loadFont = async (
  fontFamily: string,
  url: string,
  addToVariables: boolean
): Promise<void> => {
  const font = new FontFace(fontFamily, `local(${fontFamily}), url(${url})`, {
    weight: "normal",
  });
  await font.load();
  document.fonts.add(font);
  const root = document.querySelector(":root") as HTMLElement;
  if (root && addToVariables) {
    root.style.setProperty("--font", `'${fontFamily}'`);
  }
};

export const addVariableToRoot = (
  variableName: string,
  variableValue: string
) => {
  const root = document.querySelector(":root") as HTMLElement;
  if (root) {
    root.style.setProperty(`--${variableName}`, variableValue);
  }
};

export const cssDictToString = (dict?: { [key: string]: string }) => {
  let str = "";
  if (dict) {
    for (const [key, value] of Object.entries(dict)) {
      str = str + `${key}:${value};`;
    }
  }
  return str;
};

export const addStyle = (() => {
  let style = document.createElement("style");
  document.head.append(style);
  return (
    styleString: string,
    placement?: "prepend" | "append" | "replace"
  ) => {
    if (placement === "append") {
      style.textContent = style.textContent + styleString;
    } else if (placement === "prepend") {
      style.textContent = styleString + style.textContent;
    } else {
      style.textContent = styleString;
    }
  };
})();
